import React, { Component } from "react";
import firebase from "../firebase";
import { Link } from "react-router-dom";

export default class Nav extends Component {
  state = {
    pages: sessionStorage.nav ? JSON.parse(sessionStorage.nav) : [],
    showMenu: true
  };

  componentDidMount() {
    let db = firebase.database().ref("/pages");
    db.on("value", snap => {
      let val = snap.val();
      let tempArr = [];
      for (let i of val) {
        if (i) {
          tempArr.push(i);
        }
      }
      this.setState({ pages: tempArr }, () => {
        sessionStorage.nav = JSON.stringify(tempArr);
      });
    });
    window.addEventListener("resize", () => {
      if (window.innerWidth > 768 && this.state.showMenu === false) {
        this.setState({ showMenu: true });
      } else if (window.innerWidth < 768 && this.state.showMenu === true) {
        this.setState({ showMenu: false });
      }
    });
    window.addEventListener("load", () => {
      if (window.innerWidth > 768 && this.state.showMenu === false) {
        this.setState({ showMenu: true });
      } else if (window.innerWidth < 768 && this.state.showMenu === true) {
        this.setState({ showMenu: false });
      }
    });
  }

  componentDidUpdate() {
    let currentPage = `/${window.location.pathname.split("/")[1]}`;
    let navItems = document.querySelectorAll(".nav li a");
    for (let a of navItems) {
      if (a.getAttribute("href") === currentPage) {
        a.classList.add("active");
      } else {
        a.classList.remove("active");
      }
    }
  }

  toggleMenu = e => {
    let { showMenu } = this.state;
    window.scrollTo(0, 0);
    if (showMenu && window.innerWidth < 768) {
      this.setState({ showMenu: false });
    } else {
      this.setState({ showMenu: true });
    }
  };

  toggleMenuBtn = e => {
    let { showMenu } = this.state;
    if (showMenu && window.innerWidth < 768) {
      this.setState({ showMenu: false });
    } else {
      this.setState({ showMenu: true });
    }
  };

  render() {
    let { pages } = this.state;
    let nav =
      pages.length > 0 ? (
        <ul className="nav">
          <li className="mobile-btn" onClick={this.toggleMenuBtn}>
            <i className="fas fa-bars" />
          </li>
          {pages.map(
            (el, id) =>
              el.status === "live" ? (
                <li key={id}>
                  <Link
                    to={
                      el.title === "home" || el.title === "Home"
                        ? "/"
                        : `/${el.title.toLowerCase()}`
                    }
                    className={`${
                      this.state.showMenu ? "" : "hidden-item"
                    } menu-item menu-item-${id}`}
                    onClick={this.toggleMenu}
                  >
                    {el.title.charAt(0).toUpperCase() + el.title.substring(1)}
                  </Link>
                </li>
              ) : null
          )}
        </ul>
      ) : null;

    return <nav className="navigation col-xs-12 col-sm-6 col-lg-8">{nav}</nav>;
  }
}



// WEBPACK FOOTER //
// ./src/components/Nav.js